import Model, { attr } from '@ember-data/model';

export default class ReceivableInvoicesUploadModel extends Model {
  @attr declare url: string;
  @attr declare filename: string;
  @attr declare src: string | ArrayBuffer | null;

  async setPdfSrc(): Promise<void> {
    if (!this.url) return;
    let reader = new FileReader();
    let handler = () => {
      this.src = reader.result;
    };

    try {
      let response = await fetch(this.url, { method: 'GET' });
      let blob = await response.blob();

      reader.addEventListener('load', handler);
      reader.readAsDataURL(blob);
    } catch {
      this.src = null;
    } finally {
      reader.removeEventListener('load', handler);
    }
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'receivable-invoices-upload': ReceivableInvoicesUploadModel;
  }
}
